import { UUID } from "../generic/uuid";
import { GenderEnum } from "@vini-wine/core-enums";
import { GenderDto } from "@vini-wine/core-dtos";

export interface GenderModel extends UUID {
  // transform
  id: GenderEnum;
  name: string;
}

export const createGenderDtoFromAdminGenderModel = (
  gender: GenderModel,
): GenderDto => {
  return {
    id: gender.id,
    name: gender.name,
  };
};
